export default "__VITE_ASSET__Co_mypdd__"